import state from './moduleTenantState.js'
import mutations from './moduleTenantMutation.js'
import actions from './moduleTenantActions.js'
import getters from './moduleTenantGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

